import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Project } from '../../classes';

@Component({
  selector: 'geo-project',
  templateUrl: 'project.component.html',
  styleUrls: ['./project.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectComponent {
  @Input() project: Project;

  @Output() edit = new EventEmitter();
  @Output() delete = new EventEmitter();

  showProject() {
    window.location.href = `/projects/${this.project.slug}`;
  }

  editClicked(event: MouseEvent) {
    this.preventAndStop(event);
    this.edit.emit(this.project);
  }

  deleteProject(event: MouseEvent) {
    this.preventAndStop(event);
    this.delete.emit(this.project);
  }

  private preventAndStop(event: MouseEvent) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}
